import { useState, useRef, useEffect, useContext } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'
import { ModalContext } from 'components/Modals/ModalContext'

import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function ResumeWorkoutHeaderV5() {

    const navigate = useNavigate()

    const dropdownRef = useRef(null)

    const { modalData } = useContext(ModalContext)

    const activeWorkoutV5 = useSelector((state) => state.activeWorkoutV5)
    const activeWorkoutCount = Object.keys(activeWorkoutV5.activeWorkouts).length

    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    const HandleClickOutsideDropdown = (event) => {

        // If modal is open, don't handle click outside dropdown
        if (modalData !== null) {
            return
        }

        // If click is outside dropdown, close dropdown
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false)
        }
    }

    useEffect(() => {
        if (isDropdownOpen) {
            document.addEventListener('mousedown', HandleClickOutsideDropdown)
        }

        return () => {
            document.removeEventListener('mousedown', HandleClickOutsideDropdown)
        }
    }, [isDropdownOpen, modalData])

    if (activeWorkoutCount > 0) {
        return (
            <div className="relative" ref={dropdownRef}>
                <button
                    className="w-full bg-orange-400 text-white px-4 py-2 flex items-center justify-between shadow"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                    <span className='text-lg font-bold'>
                        {activeWorkoutCount} Incomplete Workout{activeWorkoutCount > 1 ? 's' : ''} Active!
                    </span>

                    {isDropdownOpen && <ChevronUpIcon className="w-6 h-6" />}
                    {!isDropdownOpen && <ChevronDownIcon className="w-6 h-6" />}
                </button>

                {isDropdownOpen && (
                    <div className="absolute w-[75%] right-0 p-2 z-50 space-y-2">
                        {Object.keys(activeWorkoutV5.activeWorkouts).map((activeWorkoutId, index) => {

                            const activeWorkout = activeWorkoutV5.activeWorkouts[activeWorkoutId]
                            var resumeWorkoutName = ''

                            if (!activeWorkout){
                                return null
                            }

                            if (activeWorkout.kinesisWorkoutAssignmentType === 'group') {
                                resumeWorkoutName = `${activeWorkout?.groupDetails?.name} - ${activeWorkout.workout.name}`
                            }
                            
                            return (
                                <div 
                                    key={index}
                                    className="flex items-center p-4 gap-x-2 bg-white rounded-xl border border-gray-400 shadow-lg"
                                >
                                    <p className='text-lg truncate'>
                                        {resumeWorkoutName}
                                    </p>

                                    <div className='flex-1' />

                                    <div className='w-24'>
                                        <BrandColorButton
                                            size="small"
                                            text="Resume"
                                            action={() => navigate(`/workout/${activeWorkoutId}/active`)}
                                        />
                                    </div>

                                    {/* 
                                    <div className='w-24'>
                                        <OutlineButton
                                            size="small"
                                            text="Discard"
                                        />
                                    </div>

                                    <div className='w-24'>
                                        <OutlineButton
                                            size="small"
                                            text="End"
                                        />
                                    </div> 
                                    */}
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        )
    }
}
